import { type FC, useEffect, useState } from 'react';
import useTranslation from 'next-translate/useTranslation';
import { Box, Button, Flex, Text } from '@eqi-investimentos/react';
import { INVESTMENT_ORDER_TYPES_TRANSLATE, type InvestmentOrder } from '@/repositories/invest/InvestRepository.types';
import { formatNumberToPTBRCurrency } from '@/utils/format';
import { IfRender } from '@/utils/jsx';
import { ConfirmSendOrderAdvisorSkeleton } from './Skeleton';
export const ConfirmSendOrderAdvisor: FC<ConfirmSendOrderAdvisorProps> = ({
  orderDataToSend,
  handleBack,
  handleConfirmAndSend
}) => {
  const {
    t
  } = useTranslation('common');
  const [loading, setLoading] = useState(true);
  const title = 'title' in orderDataToSend.asset ? orderDataToSend.asset.title : orderDataToSend.asset.name;
  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);
  return <Box pos="relative" px="3xl" w="full" h="calc(100vh - 10rem)" data-sentry-element="Box" data-sentry-component="ConfirmSendOrderAdvisor" data-sentry-source-file="index.tsx">
      <IfRender condition={loading} data-sentry-element="IfRender" data-sentry-source-file="index.tsx">
        <ConfirmSendOrderAdvisorSkeleton data-sentry-element="ConfirmSendOrderAdvisorSkeleton" data-sentry-source-file="index.tsx" />
      </IfRender>
      <IfRender condition={!loading} data-sentry-element="IfRender" data-sentry-source-file="index.tsx">
        <Flex gap="s" flexDir="column" h="full" justify="space-between" data-sentry-element="Flex" data-sentry-source-file="index.tsx">
          <Flex flexDir="column" gap="s" data-sentry-element="Flex" data-sentry-source-file="index.tsx">
            <Text size="h6" color="content.primary" data-sentry-element="Text" data-sentry-source-file="index.tsx">
              {t('screens.invest.confirmOrder.title')}
            </Text>
            <Flex justify="space-between" data-sentry-element="Flex" data-sentry-source-file="index.tsx">
              <Text size="l" color="content.primary" fontWeight="semibold" data-sentry-element="Text" data-sentry-source-file="index.tsx">
                {t('screens.invest.confirmOrder.table.asset')}
              </Text>
              <Text size="l" color="content.primary" data-sentry-element="Text" data-sentry-source-file="index.tsx">
                {title}
              </Text>
            </Flex>
            <Flex justify="space-between" data-sentry-element="Flex" data-sentry-source-file="index.tsx">
              <Text size="l" color="content.primary" fontWeight="semibold" data-sentry-element="Text" data-sentry-source-file="index.tsx">
                {t('screens.invest.confirmOrder.table.order')}
              </Text>
              <Text size="l" fontWeight="bold" color={orderDataToSend?.type === 'buy' ? 'alert.success' : 'alert.error'} data-sentry-element="Text" data-sentry-source-file="index.tsx">
                {INVESTMENT_ORDER_TYPES_TRANSLATE[orderDataToSend?.type]}
              </Text>
            </Flex>
            <Flex justify="space-between" data-sentry-element="Flex" data-sentry-source-file="index.tsx">
              <Text size="l" color="content.primary" fontWeight="semibold" data-sentry-element="Text" data-sentry-source-file="index.tsx">
                {t('screens.invest.confirmOrder.table.value')}
              </Text>
              <Text size="l" color="content.primary" data-sentry-element="Text" data-sentry-source-file="index.tsx">
                {formatNumberToPTBRCurrency(Number(orderDataToSend?.amount))}
              </Text>
            </Flex>
          </Flex>

          <Flex flexDir="column" gap="m" w="full" data-sentry-element="Flex" data-sentry-source-file="index.tsx">
            <Button w="full" onClick={handleConfirmAndSend} textTransform="capitalize" data-sentry-element="Button" data-sentry-source-file="index.tsx">
              {`${t('attributes.send')} ${t('attributes.order')}`}
            </Button>
            <Button w="full" variant="outline" onClick={handleBack} data-sentry-element="Button" data-sentry-source-file="index.tsx">
              {t('screens.invest.confirmOrder.backAndEdit')}
            </Button>
          </Flex>
        </Flex>
      </IfRender>
    </Box>;
};
type ConfirmSendOrderAdvisorProps = {
  orderDataToSend: InvestmentOrder;
  handleBack: () => void;
  handleConfirmAndSend: () => void;
};